module.exports = __webpack_public_path__ + "static/media/react-original.4f81f37c.svg";